/**
 * Trailhead launch instrumentation (TRAILHEAD_LAUNCH_TAKEOVER.md section 28).
 *
 * Events: trailhead_hero_view | trailhead_shop_click | trailhead_how_it_works_click
 *       | trailhead_companion_click | trailhead_educator_click
 *       | trailhead_keep_going_click | trailhead_app_badge_click
 *       | trailhead_scroll_depth
 *
 * Every payload carries campaign: trailhead_launch_2026 so launch traffic can be
 * separated from normal site activity.
 *
 * Listeners are delegated from the document and guarded, so the several
 * Trailhead sections on a page can each request this file without doubling up.
 */
(function () {
  if (window.__trailheadLaunchReady) return;
  window.__trailheadLaunchReady = true;

  var CAMPAIGN = 'trailhead_launch_2026';
  var CTA_EVENTS = {
    shop: 'trailhead_shop_click',
    learn: 'trailhead_how_it_works_click',
    companion: 'trailhead_companion_click',
    educator: 'trailhead_educator_click',
    keepgoing: 'trailhead_keep_going_click',
  };

  function publish(name, payload) {
    var data = payload || {};
    data.campaign = CAMPAIGN;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {
      /* customer pixels may not be listening */
    }
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: data }));
    } catch (e2) {
      /* ignore */
    }
  }

  function surface() {
    if (document.querySelector('[data-trailhead-surface="hub"]')) return 'hub';
    if (document.querySelector('[data-trailhead-surface="launch"]')) return 'homepage';
    if (document.body.classList.contains('template-product')) return 'pdp';
    return 'other';
  }

  /**
   * The educator and Keep Going bands reuse shared Jaromin sections that carry no
   * Trailhead markup, so on the hub those two CTAs are recognised by destination.
   */
  function ctaFromHref(href) {
    if (!href) return null;
    if (href.indexOf('/pages/educators') !== -1) return 'educator';
    if (href.indexOf('heyinglewood.com') !== -1) return 'keepgoing';
    if (href.indexOf('/continue') !== -1) return 'keepgoing';
    if (href.indexOf('/blogs/') !== -1) return 'keepgoing';
    return null;
  }

  function trackClicks(where) {
    document.addEventListener('click', function (event) {
      var badge = event.target.closest ? event.target.closest('[data-trailhead-badge]') : null;
      if (badge) {
        publish('trailhead_app_badge_click', {
          platform: badge.getAttribute('data-trailhead-badge'),
          context: badge.getAttribute('data-trailhead-context') || where,
          surface: where,
        });
        return;
      }

      var cta = event.target.closest ? event.target.closest('[data-trailhead-cta]') : null;
      if (cta) {
        var name = CTA_EVENTS[cta.getAttribute('data-trailhead-cta')];
        if (name) {
          publish(name, {
            context: cta.getAttribute('data-trailhead-context') || where,
            surface: where,
            href: cta.getAttribute('href') || '',
          });
        }
        return;
      }

      if (where !== 'hub') return;
      var link = event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      var kind = ctaFromHref(link.getAttribute('href'));
      if (kind) {
        publish(CTA_EVENTS[kind], {
          context: 'hub_body',
          surface: where,
          href: link.getAttribute('href') || '',
        });
      }
    });
  }

  function trackHeroView(where) {
    var hero = document.querySelector('[data-trailhead-hero-copy]');
    if (!hero) return;
    if (!('IntersectionObserver' in window)) {
      publish('trailhead_hero_view', { surface: where });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          publish('trailhead_hero_view', { surface: where });
          observer.disconnect();
        });
      },
      { threshold: 0.5 }
    );
    observer.observe(hero);
  }

  function trackScrollDepth(where) {
    if (where !== 'hub') return;
    var marks = [25, 50, 75, 100];
    var sent = {};

    function check() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var pct = Math.min(100, Math.round((window.scrollY / scrollable) * 100));
      marks.forEach(function (mark) {
        if (pct >= mark && !sent[mark]) {
          sent[mark] = true;
          publish('trailhead_scroll_depth', { surface: where, depth: mark });
        }
      });
      if (sent[100]) window.removeEventListener('scroll', onScroll);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        check();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    check();
  }

  function boot() {
    var where = surface();
    trackClicks(where);
    trackHeroView(where);
    trackScrollDepth(where);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
